export const facebookMessageConfirmOrderActions = {
  FILTER_KEYWORD_UPDATE: 'FILTER_KEYWORD_UPDATE',
  MESSAGE_CONFIRM_LIST_UPDATE: 'MESSAGE_CONFIRM_LIST_UPDATE',
  MESSAGE_CONFIRM_LOADING_UPDATE: 'MESSAGE_CONFIRM_LOADING_UPDATE',
  MESSAGE_CONFIRM_MODAL_STATUS:"MESSAGE_CONFIRM_MODAL_STATUS",
  MESSAGE_CONFIRM_GET_DETAIL:"MESSAGE_CONFIRM_GET_DETAIL",
  MESSAGE_CONFIRM_CHANGE_MESSAGE:"MESSAGE_CONFIRM_CHANGE_MESSAGE",
  MESSAGE_CONFIRM_CHANGE_STATUS:"MESSAGE_CONFIRM_CHANGE_STATUS",
  MESSAGE_CONFIRM_RESET_CONTENT:"MESSAGE_CONFIRM_RESET_CONTENT",
  VALIDATE_MESSAGE_CONFIRM:"VALIDATE_MESSAGE_CONFIRM",
  MESSAGE_CONFIRM_LIVESTREAM_CHANGE_MESSAGE: "MESSAGE_CONFIRM_LIVESTREAM_CHANGE_MESSAGE",
  MESSAGE_CONFIRM_LIVESTREAM_CHANGE_STATUS: "MESSAGE_CONFIRM_LIVESTREAM_CHANGE_STATUS",
  MESSAGE_CONFIRM_LIVESTREAM_RESET_CONTENT: "MESSAGE_CONFIRM_LIVESTREAM_RESET_CONTENT",
  VALIDATE_LIVESTREAM_MESSAGE: "VALIDATE_LIVESTREAM_MESSAGE",
}
